import { QueryClient, useMutation, UseMutationResult, useQuery, UseQueryResult } from "react-query"
import Settings from "utils/CarrotConfig"
import CarrotClient from "lib/carrot-api"
import ResponseError from "utils/ResponseError"
import { RetryConfig } from "utils/ErrorHandling"
import { CarrotPlanEmployeeSettings } from "../../../types/CarrotPlanEmployeeSettings"

const client = new CarrotClient(Settings.CARROT_BACKEND_URL)

const CACHE_KEY = "EmployeeSettings"

const loadEmployeeSettings = async (employeeId: number): Promise<CarrotPlanEmployeeSettings> => {
  return await client.getCarrotPlanEmployeeSettings(employeeId)
}

const getCacheKey = (employeeId: number): (string | number)[] => [CACHE_KEY, employeeId]

export function useEmployeeSettings(employeeId: number): UseQueryResult<CarrotPlanEmployeeSettings, ResponseError> {
  return useQuery(getCacheKey(employeeId), () => loadEmployeeSettings(employeeId), {
    ...RetryConfig
  })
}

export function useSetMemberRejectedCarrotPlan(
  queryClient: QueryClient,
  employeeId
): UseMutationResult<void, ResponseError, boolean> {
  const submitData = async (newValue): Promise<void> => {
    await client.setMemberRejectedCarrotPlan({
      employeeId: employeeId,
      payload: newValue
    })
  }

  return useMutation<void, ResponseError, boolean>((newValue) => submitData(newValue), {
    ...RetryConfig,
    onSuccess: () => {
      queryClient.invalidateQueries(getCacheKey(employeeId)).then()
    }
  })
}
